import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Product Roadmap Software and Tools | Canny';
const Description =
  'Roadmapping made easy! Organize your ideas, collect user feedback, prioritize features, build your roadmap, and communicate what your team is working on.';
const Image = 'https://canny.io/images/canny-social.png';
const ProductRoadmapUrl = 'https://canny.io/features/product-roadmap';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${ProductRoadmapUrl}#webpage`,
    url: ProductRoadmapUrl,
    name: 'Product Roadmap - Canny',
    description:
      "Plan and communicate your product strategy with Canny's roadmap feature, helping teams prioritize and share what's coming next.",
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createWebApplicationItemList(
    `${ProductRoadmapUrl}#capabilities`,
    'Product Roadmap Capabilities',
    [
      {
        name: 'Visual Roadmap Planning',
        description:
          'Create and maintain a visual roadmap that aligns teams and communicates upcoming initiatives.',
      },
      {
        name: 'Feature Prioritization',
        description:
          'Build your own prioritization formula based on customer feedback, user data, and effort required to prioritize features more effectively.',
      },
      {
        name: 'Customer & Stakeholder Communication',
        description:
          'Share roadmap updates with customers and internal teams to keep everyone aligned.',
      },
      {
        name: 'Integration with Feedback',
        description:
          'Connect roadmap items directly with collected feedback to show how requests influence product strategy.',
      },
    ],
  ),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Features', item: 'https://canny.io/features' },
    { name: 'Product Roadmap', item: ProductRoadmapUrl },
  ]),
]);

export default class LandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: ProductRoadmapUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
